import { Base } from '@gate31/core/src/libs/BaseComponent';
import { CustomCn } from '@gate31/core/src/libs/classname';

// На странице корзины запускается только если клиент авторизован
export class CartLoyaltyBonuses extends Base<HTMLElement> {
    cn: CustomCn;

    buttonSubmit: HTMLButtonElement | undefined;
    form: HTMLElement;
    variantButtons: NodeListOf<HTMLInputElement>;
    variantButtonBonusesEarn: HTMLInputElement | null;
    collectedWrap: HTMLSpanElement;
    balanceWrap: HTMLSpanElement;
    buttonReset: HTMLElement;

    radioButtonUserBonuses: HTMLInputElement;

    fieldBonuses: HTMLInputElement | null

    constructor(options: { node: HTMLElement; cn: CustomCn }) {
        super(options.node);

        this.cn = options.cn;

        this.radioButtonUserBonuses = this.getRoot().querySelector<HTMLInputElement>(this.cn.setElem('bonuses-use').toSelector()) as HTMLInputElement;
        this.form = this.getRoot().querySelector(this.cn.setElem('content').toSelector()) as HTMLElement;
        this.buttonSubmit = this.getRoot().querySelector<HTMLButtonElement>(this.cn.setElem('loyalty-button').toSelector()) as HTMLButtonElement;
        this.buttonReset = this.getRoot().querySelector<HTMLButtonElement>(this.cn.setElem('reset-button').toSelector()) as HTMLButtonElement;
        this.collectedWrap = this.getRoot().querySelector(this.cn.setElem('header-button-counter-collected').toSelector()) as HTMLElement;
        this.balanceWrap = this.getRoot().querySelector(this.cn.setElem('header-button-counter-balance').toSelector()) as HTMLElement;

        this.variantButtons = this.getRoot().querySelectorAll<HTMLInputElement>('input' + this.cn.setElem('radio-btn').toSelector()) as NodeListOf<HTMLInputElement>;
        this.variantButtonBonusesEarn = this.getRoot().querySelector(String(this.cn.setElem('bonuses-earn').toSelector()) + ' ' + 'input[type="radio"]');

        // Поле в кол-вом списываемых бонусов которое видит пользователь
        this.fieldBonuses = this.getRoot().querySelector<HTMLInputElement>(this.cn.setElem('bonuses-input').toSelector()) as HTMLInputElement;

        this.callbackConnection();
    }

    callbackConnection() {
        // Для актуального состояния кнопки
        this.changeButton(this.fieldBonuses?.value || '');

        this.fieldBonuses?.addEventListener('input', e => {
            const target = e.target as HTMLInputElement;

            this.changeButton(target.value);
        });

        // Для актуализации стратегии ПЛ (списание/начисление)
        this.variantButtons.forEach(input => {
            input.addEventListener('change', e => {
                const target = e.target as HTMLInputElement;

                this.handleToggleVariant(target);
            });
        });
    }

    getFiledFromHtmlById(id: number): HTMLInputElement | undefined {
        return this.getRoot().querySelector(`[name="order[fields_values_attributes][${id}][value]"]`) as HTMLInputElement | undefined;
    }

    getFiledValueFromHtml(id: number) {
        const field = this.getFiledFromHtmlById(id);

        return field?.value || '';
    }

    changeButton(value: string) {
        if (value) {
            this.buttonSubmit?.removeAttribute('disabled');
        } else {
            this.buttonSubmit?.setAttribute('disabled', '');
        }
    }

    hiddenUseBonuses() {
        this.radioButtonUserBonuses.classList.add('hidden');
    }

    chooseShowOrHiddenUsedBonuses() {
        // const isCoupon = Cart.order.coupon ? Cart.order.coupon.valid : false;
        // const selectedDiscount = Cart.order.discounts[0] ? Cart.order.discounts[0].amount : 0;
        // const maxToApplyBonuses = Number(this.state.bonuses.maxToApply);

        // if (maxToApplyBonuses <= selectedDiscount) {
        //     this.hiddenUseBonuses();
        // }
    }
    /**
     * Переключает варианты программы лояльности. Накопление или списание
     */
    handleToggleVariant(target: HTMLInputElement | undefined) {
        const hiddenFormClass = this.cn.setElem('content_hidden').toString();

        // Использовать баллый
        if (target?.value === 'Use-points') {
            this.form.classList.remove(hiddenFormClass);
        }

        // Накапливать баллый
        if (target?.value === 'Earn-points') {
            this.form.classList.add(hiddenFormClass);
        }
    }

    renderCollected(collectedBonuses: number) {
        if (this.collectedWrap) {
            this.collectedWrap.innerHTML = String(`+ ${(collectedBonuses || '0').toLocaleString()}`);
        }
    }

    renderBalance(maxToApply: number) {
        if (this.balanceWrap) {
            this.balanceWrap.innerHTML = String((maxToApply || '0').toLocaleString());
        }
    }

    addLimitation(maxToApply: number) {
        this.fieldBonuses?.addEventListener('input', () => {
            const value = Number(this.fieldBonuses?.value) || 0;
            const maxValue = Number(maxToApply);

            if (typeof value === 'number' && typeof maxValue === 'number' && value > maxValue) {
                if (! this.fieldBonuses) {
                    return;
                }

                this.fieldBonuses.value = String(maxToApply);
            }
        });
    }
}
